import orderOptimizerTranslationsHelper from "../../../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableColumn from "../types/order-optimizer-raily-details-hidden-details-heading-tables-driver-table-column";

const getColumns =
  (): OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableColumn[] => {
    const translations =
      orderOptimizerTranslationsHelper.getRailyDetailsTranslations().table
        .headingTables.driver;

    const tableColumns: OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableColumn[] =
      [
        {
          header: translations.totalTimeLabel,
          title: translations.totalTimeTitle,
          accessor: "totalTime",
          colSpan: 3,
        },
        {
          header: translations.haltingTimeLabel,
          title: translations.haltingTimeTitle,
          accessor: "haltingTime",
          colSpan: 3,
        },
        {
          header: translations.totalDrivingTimeLabel,
          title: translations.totalDrivingTimeTitle,
          accessor: "totalDrivingTime",
          colSpan: 3,
        },
        {
          header: translations.distanceLabel,
          title: translations.distanceTitle,
          accessor: "distance",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableHelper = {
  getColumns,
};

export default orderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableHelper;
